<template>
  <div class="bp-table-responsive">
    <div v-if="loading" class="text-center py-9">
      <b-spinner variant="primary" />
    </div>
    <div v-else-if="!data.length" class="pt-6">
      <slot name="empty">
        <div class="container centralize-row text-center pt-5 my-6 mt-9">
          <div class="row justify-content-center">
            <div class="col-lg-5">
              <img
                class="d-block mb-5 mx-auto"
                src="@/assets/images/home/welcome.png"
              />
              <h5>{{ emptyMessage }}</h5>
            </div>
          </div>
        </div>
      </slot>
    </div>

    <div v-else class="body">
      <div class="d-none d-lg-block border-bottom">
        <div class="grid-table" :style="column_sizes">
          <div
            v-for="(column, column_index) in column_list"
            :key="column_index"
            class="table-head small d-flex align-items-center py-3 pl-3 pl-lg-0"
          >
            <slot v-if="column.selectable" name="batch-selectable">
              <div class="d-none d-lg-flex align-items-center">
                <b-form-checkbox
                  :id="`activate-all-batch-opened-${column_index}`"
                  v-model="all_active"
                  :indeterminate="indeterminate"
                  @change="on_selectable_all"
                />
                <span class="mr-3">{{ column.name }}</span>
              </div>
            </slot>
            <slot v-else :name="`head-${column.name}`">
              {{ column.name }}
            </slot>
          </div>
        </div>
      </div>
      <div class="d-block d-lg-none border-bottom mb-3">
        <bp-select
          id=""
          size="sm"
          v-model="active_column"
          :options="columnOptions"
          placeholder="Selecione a categoria"
          label="Visualizar categoria"
        />
        <div class="d-flex justify-content-start pt-6">
          <slot v-if="selectable" name="batch-selectable">
            <div class="d-flex d-lg-none align-items-center ml-3">
              <b-form-checkbox
                :id="`activate-all-batch-opened`"
                v-model="all_active"
                :indeterminate="indeterminate"
                @change="on_selectable_all"
              />
              <span>Ativar todas</span>
            </div>
          </slot>
        </div>
      </div>

      <component
        v-for="(item, index) in data"
        :is="clickable ? 'button' : 'div'"
        :key="index"
        @click="clickItem(item, index)"
        class="grid-table item border-bottom"
        :style="column_sizes"
        :class="{
          clickable,
          opened: opened[index]
        }"
      >
        <div
          v-if="opened[index]"
          class="d-flex d-lg-none justify-content-between w-100"
        >
          <slot
            :name="`body-${column_list[0].name}`"
            :item="item"
            :i="index"
            :column="columns"
            :active="active_column"
            :opened="opened[index]"
          >
            <template v-if="is_valid_field(item, column_list[0])">
              <template v-if="typeof item[column_list[0].field] == 'boolean'">
                <b-form-checkbox
                  class="d-none d-lg-block"
                  :id="`data-field-${ic}-${index}`"
                  v-model="item[column_list[0].field]"
                  @change="on_change_selectable_item"
                />
                <span class="d-lg-none">-</span>
              </template>
              <a
                v-else-if="column_list[0].type && column_list[0].type == 'link'"
                class="fa-light fa-link mr-2"
                :href="item[column_list[0].field]"
              ></a>
              <span v-else>
                {{ get_field_value(item, column_list[0]) }}
              </span>
            </template>
            <span v-else class="text-secondary">
              {{ column_list[0].default }}
            </span>
          </slot>
          <button class="btn btn-sm pr-0 mr-0" @click="open_close_item(index)">
            <i class="fa-light fa-angle-up"></i>
          </button>
        </div>
        <div
          v-if="selectable && selectable.field && opened[index]"
          class="item-wrapper"
        >
          <b-form-checkbox
            :id="`checkbox-opened-item-${index}`"
            v-model="item[selectable.field]"
            @change="on_change_selectable_item"
          >
            {{ selectable.name }}
          </b-form-checkbox>
        </div>
        <template v-for="(column, ic) in handle_columns(column_list, index)">
          <div
            v-if="show_body_column(index, column.name, ic)"
            :key="`item-wrapper-${ic}-${index}`"
            class="item-wrapper"
            @click.stop="() => handle_click(item, column, index)"
            :class="{
              openbtn: show_open_button(index, ic),
              'cursor-pointer': !!column.onClick
            }"
          >
            <b-form-checkbox
              v-if="show_mobile_closed_item_checkbox(index, ic)"
              :id="`checkbox-closed-item-${index}`"
              v-model="item[selectable.field]"
              @change="on_change_selectable_item"
            />
            <div v-if="opened[index]">{{ column.name }}</div>
            <span v-if="!opened[index] && ic == 0">
              {{ get_field_value(item, column) }}
            </span>
            <slot
              v-else
              :name="`body-${column.name}`"
              :item="item"
              :i="index"
              :column="column"
              :active="active_column"
              :opened="opened[index]"
            >
              <template v-if="is_valid_field(item, column)">
                <template
                  v-if="typeof get_field_value(item, column) == 'boolean'"
                >
                  <b-form-checkbox
                    class="d-none d-lg-block"
                    :id="`data-field-${ic}-${index}`"
                    :value="get_field_value(item, column)"
                    @input="v => set_field_value(item, column, v)"
                    @change="on_change_selectable_item"
                  />
                  <span class="d-lg-none">-</span>
                </template>
                <a
                  v-else-if="column.type && column.type == 'link'"
                  class="fa-light fa-link mr-2"
                  :href="get_field_value(item, column)"
                ></a>
                <template v-else-if="column.type == 'menu'">
                  <div
                    class="d-none d-lg-flex align-items-center justify-content-end w-100"
                  >
                    <bp-dropdown :id="`dropdown-menu-${ic}-${index}`" dropleft>
                      <bp-dropdown-item
                        v-for="(option, option_index) in get_options(
                          item,
                          column
                        )"
                        :key="`column-menu-${option_index}`"
                        @click="handle_option_click(option, item)"
                      >
                        <div
                          class="d-flex align-items-center"
                          :class="
                            `text-neutral-600 fs-14 fw-4 ${option.class || ''}`
                          "
                        >
                          <i v-if="option.icon" :class="option.icon"></i>
                          <span class="text-left pl-3">
                            {{ option.label }}
                          </span>
                        </div>
                      </bp-dropdown-item>
                    </bp-dropdown>
                  </div>
                  <div v-if="opened[index]" class="d-lg-none w-100">
                    <button
                      v-for="(option, option_index) in get_options(
                        item,
                        column
                      )"
                      :key="`column-menu-mobile-${option_index}`"
                      class="btn btn-block btn-new-secondary px-3"
                      :class="`${option.class || ''}`"
                      @click.stop="handle_option_click(option, item)"
                    >
                      <i v-if="option.icon" :class="`${option.icon} mr-3`"></i>
                      {{ option.label }}
                    </button>
                  </div>
                </template>
                <span
                  v-else-if="typeof get_field_value(item, column) == 'string'"
                  v-html="get_field_value(item, column)"
                ></span>
                <div
                  v-else-if="
                    typeof get_field_value(item, column) == 'object' &&
                      get_field_value(item, column).component &&
                      get_field_value(item, column).onClick
                  "
                  v-html="get_field_value(item, column).component"
                  style="cursor: pointer;"
                ></div>
              </template>
              <span v-else class="text-secondary">
                {{ column.default }}
              </span>
            </slot>
            <button
              v-if="show_open_button(index, ic)"
              class="btn btn-sm d-lg-none pr-0 mr-0"
              @click="open_close_item(index)"
              :key="`open-close-${ic}`"
            >
              <i class="fa-light fa-angle-down" />
            </button>
          </div>
        </template>
      </component>
    </div>
    <div
      v-if="pagination"
      class="d-flex justify-content-center justify-content-lg-end pt-5"
    >
      <bp-paginator
        v-show="data.length"
        :pagination="pagination"
        @on-update="paginationRemoteMethod"
        :ref="paginatorRef"
      />
    </div>
    <confirmation
      v-if="confirmation_data"
      newDesign
      iconType="warning"
      :type="confirmation_data.option.confirmation.type"
      title="Aviso"
      cancelButtonText="Cancelar"
      v-model="confirmation_visible"
      :confirmButtonClass="
        confirmation_data.option.confirmation.submitButtonClass
      "
      :confirmButtonText="confirmation_data.option.confirmation.submitText"
      :text="confirmation_data.option.confirmation.text"
      @confirm="confirmation_data.option.click(confirmation_data.item)"
      @cancel="handle_cancel_confirmation"
    />
  </div>
</template>

<script>
import { BpSelect } from "@/components/designSystem";
import isMobile from "ismobilejs";
import _ from "lodash";
import BpPaginator from "../BpPaginatorOld.vue";
export default {
  components: { BpSelect, BpPaginator },
  props: {
    clickable: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: [Array, Object],
      default: () => []
    },
    frSize: {
      type: [String, Object],
      default: ""
    },
    paginationRemoteMethod: {
      type: Function,
      default: () => {}
    },
    pagination: {
      type: Object,
      default: null
    },
    emptyMessage: {
      type: String,
      default: "Ainda não há nada aqui!"
    },
    loading: {
      type: Boolean,
      default: false
    },
    paginatorRef: {
      type: String,
      default: "paginator"
    }
  },
  data() {
    return {
      active_column: "",
      all_active: false,
      confirmation_visible: false,
      confirmation_data: null,
      opened: this.data.reduce((a, _, i) => ({ ...a, [i]: false }), {})
    };
  },
  mounted() {
    this.active_column = this.column_list[1]?.name;
  },
  computed: {
    column_list() {
      return this.columns.map(c => ({
        name: typeof c == "string" ? c : _.get(c, "name", ""),
        default: typeof c == "string" ? "-" : _.get(c, "default", "-"),
        field: typeof c == "string" ? null : _.get(c, "field", null),
        type: typeof c == "string" ? null : _.get(c, "type", null),
        transform: typeof c == "string" ? null : _.get(c, "transform", null),
        selectable:
          typeof c == "string" ? false : _.get(c, "selectable", false),
        options: typeof c == "string" ? false : _.get(c, "options", false),
        onClick: typeof c == "string" ? false : _.get(c, "onClick", false)
      }));
    },
    selectable() {
      return this.columns.find(c => _.get(c, "selectable", false));
    },
    indeterminate() {
      return Boolean(
        this.data.find(item => item[this.selectable.field]) &&
          this.data.find(item => !item[this.selectable.field])
      );
    },
    isDesktop() {
      return !isMobile().any;
    },
    columnOptions() {
      return this.column_list
        .filter((v, i) => i > 0 && v.name.length)
        .map(c => ({
          label: c.name,
          name: c.name,
          id: c.name
        }));
    },
    gridFractions() {
      if (this.frSize) {
        if (typeof this.frSize == "string") {
          return this.frSize;
        }
        return this.isDesktop ? this.frSize.desktop : this.frSize.mobile;
      }

      return Array(this.columns.length)
        .fill("1fr")
        .join(" ");
    },
    column_sizes() {
      return { "grid-template-columns": this.gridFractions };
    }
  },
  methods: {
    handle_click(item, column, index) {
      if (
        typeof this.get_field_value(item, column) == "object" &&
        this.get_field_value(item, column).onClick
      ) {
        this.get_field_value(item, column).onClick(item, index);
      } else if (column.onClick) {
        column.onClick(item, index);
      }
    },
    handle_columns(columns, index) {
      if (this.opened[index]) {
        return columns.filter((_, i) => i > 0);
      }

      return columns;
    },
    is_valid_field(item, column) {
      const value = this.get_field_value(item, column);
      return (
        column.type == "menu" ||
        (column.field && value !== null && value !== undefined && value !== "")
      );
    },
    get_field(item, column) {
      return column.field && item[column.field] ? item[column.field] : column;
    },
    get_field_value(item, column) {
      if (column.transform) {
        return column.transform(_.get(item, column.field, ""), item);
      }
      return _.get(item, column.field, "");
    },
    set_field_value(item, column, value) {
      _.set(item, column.field, value);
    },
    get_options(item, column) {
      if (typeof column.options == "function") return column.options(item);
      return column.options;
    },
    open_close_item(index) {
      const nw_op = { ...this.opened };
      nw_op[index] = !nw_op[index];
      this.opened = nw_op;
    },
    show_body_column(data_index, column, column_index) {
      return (
        this.opened[data_index] ||
        this.isDesktop ||
        this.active_column == column ||
        column_index == 0 ||
        column_index == this.column_list.length - 1
      );
    },
    show_open_button(data_index, column_index) {
      if (this.isDesktop) return false;

      return (
        !this.opened[data_index] && column_index == this.column_list.length - 1
      );
    },
    show_mobile_closed_item_checkbox(index, ic) {
      return (
        !this.isDesktop &&
        !this.opened[index] &&
        ic == 0 &&
        this.selectable &&
        this.selectable.field
      );
    },
    clickItem(item, index) {
      if (this.clickable) {
        this.$emit("clickItem", item, index);
      }
    },
    on_change_selectable_item(val) {
      if (this.selectable && this.selectable.field) {
        const is_all_selected = this.data.reduce(
          (a, c) => a && c[this.selectable.field],
          true
        );

        this.all_active = is_all_selected;
      }
    },
    on_selectable_all(val) {
      let value = val;
      if (this.indeterminate) {
        value = false;
      }

      for (let k in this.data) {
        this.data[k][this.selectable.field] = value;
      }
      this.all_active = value;
    },
    handle_option_click(option, item) {
      if (_.get(option, "confirmation.enable", false)) {
        this.confirmation_data = { option, item };
        setTimeout(() => {
          this.confirmation_visible = true;
        }, 100);
      } else {
        option.click(item);
      }
    },
    handle_cancel_confirmation() {
      this.confirmation_visible = false;
      this.confirmation_data = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-table-responsive {
  font-size: 14px;
  .border-bottom {
    border-bottom: 1px solid #dee2e6 !important;
  }
  .border-top {
    border-top: 1px solid #dee2e6 !important;
  }

  .item-wrapper {
    text-align: left;
  }

  .grid-table {
    display: grid;
    align-items: center;
    background: transparent;
    width: 100%;
    border: none;

    @media screen and (min-width: 992px) {
      align-items: center;
    }

    &.opened {
      @media screen and (max-width: 991px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        .item-wrapper {
          width: 100%;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }

  .table-head {
    color: var(--Semantic-Secondary-Accent-500, #7c7c7c);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.08px;
    @media screen and (max-width: 1470px) {
      font-size: 14px;
    }
  }

  .item {
    & > * {
      display: flex;
      align-content: flex-start;
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.056px;
      color: var(--Semantic-Neutral-600, #666);
      @media screen and (max-width: 1470px) {
        font-size: 13px;
      }
      &.openbtn {
        justify-content: flex-end;
      }
    }
    transition: 0.2s all;
    &.clickable {
      &:hover {
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
      }
    }
    &.selected {
      border-top: 1px solid var(--Semantic-Primary-Accent-500, #8323ff);
      border-bottom: 1px solid var(--Semantic-Primary-Accent-500, #8323ff);
      background: var(--Surface-Cumulative-minus4, rgba(25, 25, 34, 0.02));
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
